export const WISH_LIST = '/wish-list';
